import { z } from "zod";

/**
 * M7 — the clean universe by UTC hour of day, all 24 hours always present.
 *
 * `cleanProposals` and `humanVsHuman` MUST sum to the `cleanUniverse` and
 * `cleanHvh` of route 22 over the same window. That is the cheapest
 * internal-consistency check on the tab and it is asserted in the backend tests.
 */
export const ArenaOpsMatchmakingMatchesByHourResponseSchema = z.object({
  hours: z.array(
    z.object({
      hourUtc: z.number().int().min(0).max(23),
      /** Proposals surviving the exclusions — NOT every proposal in the hour. */
      cleanProposals: z.number().int(),
      /** Of those, the ones that passed the ready check (`CONFIRMED`). */
      confirmed: z.number().int(),
      humanVsHuman: z.number().int(),
      humanVsBot: z.number().int(),
    }),
  ),
});
export type ArenaOpsMatchmakingMatchesByHourResponse = z.infer<typeof ArenaOpsMatchmakingMatchesByHourResponseSchema>;
